import axios from 'axios';
import {CSRF_TOKEN} from './csrf_token';

export const AXIOS = axios.create({
  headers: {
    'X-CSRF-Token': CSRF_TOKEN,
    'X-REQUESTED-WITH': 'XMLHttpRequest',
    'Content-Type': 'application/json'
  }
});